/**
 * Copyright © 2019 2020 2021 7thCode.(http://seventh-code.com/)
 * This software is released under the MIT License.
 * opensource.org/licenses/mit-license.php
 */

"use strict";

import {Directive, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {IErrorObject} from "../../../../../types/platform/universe";
import {Guests2Service} from "../guests2.service";
import {WelcomeDialogComponent} from "./welcome-dialog.component";
import {AigiaAuth2Service} from "../../auth/aigia-auth2.service";
import {InfoDialogComponent} from "../../../platform/base/components/info-dialog/info-dialog.component";

@Directive({
	selector: "[welcome-dialog]",
})

export class WelcomeDialogDirective {

	@Input() public auth: any;
	@Input() public user: { username: string, user_id: string, enable_reservation_link: boolean };
	@Output() public success = new EventEmitter<any>();
	@Output() public error = new EventEmitter<any>();

	private resultDialogContent: any = {title: "会員", message: "作成しました."};

	constructor(
		private matDialog: MatDialog,
		private accountService: Guests2Service,
		private authService: AigiaAuth2Service
	) {
	}

	/*
	* */
	private Complete(type: string, value: any): void {
		this.success.emit({type, value});
	}

	/*
	* */
	private Error(type: string, value: any): void {
		this.error.emit({type, value});
	}

	/*
	* */
	@HostListener("click", ["$event.target"])
	public createDialog(): void {
		const dialog: MatDialogRef<any> = this.matDialog.open(WelcomeDialogComponent, {
			width: "50%",
			minWidth: "320px",
			height: "fit-content",
			data: {
				content: {},
				auth: this.auth,
				user: this.user,
			},
			disableClose: true,
		});

		dialog.beforeClosed().subscribe((result: { content: { username: string, password: string, confirm_password: string, nickname: string, origin_username: string, auth: number, type: string } }): void => {
			if (result) { // if not cancel then
				const content = result.content;
				const username: string = content.username;
				const password: string = content.password;
				const category: string = "";
				const type: string = content.type;
				const auth: number = content.auth;
				const origin_username: string = content.origin_username;

				if (result.content.username) {
					delete result.content.username;
				}

				if (result.content.password) {
					delete result.content.password;
				}

				if (result.content.confirm_password) {
					delete result.content.confirm_password;
				}

				this.authService.regist_immediate_with_relation(auth, username, password, category, type, result.content, origin_username, (error: IErrorObject, result: object): void => {
					if (!error) {
						const info_dialog: MatDialogRef<any> = this.matDialog.open(InfoDialogComponent, {
							width: "50%",
							minWidth: "320px",
							height: "fit-content",
							data: {content: this.resultDialogContent},
							disableClose: true,
						});

						info_dialog.afterClosed().subscribe((result: any): void => {
							this.Complete("", result);
						});
					} else {
						this.Error("", error);
					}
				});
			}
		});

		dialog.afterClosed().subscribe((result: any): void => {

		});
	}

}
